import * as React from 'react'

import TabLinks from '../../ui/tabLinks'

import { TabLink } from '../../../store/commonTypes'

import paths from '../../../paths'

const FavoriteTabs: React.FunctionComponent = () => {
    const links: TabLink[] = [
        {
            label: 'Contributions',
            path: paths.favoriteContributions.path
        },
        {
            label: 'Contributors',
            path: paths.favoriteContributors.path
        }
    ]

    return <TabLinks links={links} />
}

export default FavoriteTabs
